import { CopyToClipboard } from '@/components/CopyToClipboard/CopyToClipboard';
import { LineTypeIntelligenceType } from '@/types';
import { cn } from '@/utils/format';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { ChatBubbleBottomCenterIcon, PhoneIcon } from '@heroicons/react/24/solid';

interface PhoneButtonProps {
  phone: string | null | undefined;
  variant?: 'sm' | 'lg';
  isInvalid?: boolean;
  preferSms?: boolean;
  phoneType?: LineTypeIntelligenceType | null;
}

export const PhoneButton = ({
  phone,
  variant = 'sm',
  isInvalid = false,
  preferSms = false,
  phoneType,
}: PhoneButtonProps) => {
  if (!phone) isInvalid = true;
  return (
    <span
      className={cn(
        'inline-flex flex-row align-middle items-center justify-center border rounded shadow-xs',
        isInvalid
          ? 'bg-red-100 border-red-300 dark:bg-red-900/50 dark:border-red-900'
          : 'bg-background border-zinc-300 dark:border-zinc-700 hover:bg-gt-green-50 hover:dark:bg-gt-green-900/50',
      )}
    >
      <span
        className={cn(
          'mr-1 border-r rounded-l',
          isInvalid
            ? 'bg-red-200 border-red-400 dark:bg-red-900/50 dark:border-red-900'
            : 'bg-background/10 border-zinc-300 dark:border-zinc-700',
        )}
      >
        {preferSms && (!phoneType || phoneType === LineTypeIntelligenceType.mobile) ? (
          <ChatBubbleBottomCenterIcon
            className={cn('h-4 w-4 m-1', isInvalid ? 'text-red-400' : 'text-foreground/40')}
          />
        ) : (
          <PhoneIcon
            className={cn('h-4 w-4 m-1', isInvalid ? 'text-red-400' : 'text-foreground/40')}
          />
        )}
      </span>
      {phone ? (
        <>
          <a
            href={`tel:+1${phone.replace(/\D/g, '')}`}
            className={cn(
              'grow font-semibold mr-1.5 pl-1',
              'text-nowrap whitespace-nowrap text-ellipsis overflow-hidden',
              variant === 'sm' ? 'text-xs' : 'tracking-tighter text-xs lg:text-base',
              isInvalid ? 'text-red-500' : 'text-foreground/85',
            )}
          >
            {phone}
          </a>
          {isInvalid ? (
            <ExclamationTriangleIcon className="h-4 w-4 m-1 text-red-500" />
          ) : (
            <CopyToClipboard value={phone} />
          )}
        </>
      ) : (
        <span
          className={cn(
            'grow font-semibold mr-1.5 pl-1',
            'text-nowrap whitespace-nowrap text-ellipsis overflow-hidden',
            variant === 'sm' ? 'text-xs' : 'tracking-tighter text-xs lg:text-base',
            isInvalid ? 'text-red-500' : 'text-foreground/85',
          )}
        >
          No phone number
        </span>
      )}
    </span>
  );
};
